export const login = "/check";
export const verfiyCode = "/validation";
export const register = "/registeruser";
export const logout = "/logout";
export const blogs = "/blog/weblist";
export const blogSingle = "/blog/single";
export const sendComment = "/comment/store";
export const storeContactUs = "/connectus/store";
export const userDashboard = "/dashboard/user";
export const plans = "/plan/list";
export const buyPlan = "/plan/buy";
export const editPorfile = "/profile/edit";
export const supportChat = "/support/chat";
export const supportList = "/support/user_list";
export const supportNewQuestion = "/support/new_question";
export const newTicket = "/support/store";
export const nesdata = "/nesdata";
export const createAds = "/user/ads/create";
export const updateAds = "/user/ads/update";
export const listAds = "/user/ads/list";
export const adsShow = "/user/ads/show";
export const listWeb = "/web/ads";
export const aboutUs = "/about_us/data";
export const Contact_us = "/contact_us/data";
export const footerData = "/footer/data";
export const newsLetter = "/email_news/store";
export const landingData = "/landing/data";
export const single = "/web/single";
export const toggleMark = "/marked/toggle";
export const listMark = "/marked/list";
export const myPayments = "/user/peyments";
export const singlePement = "/user/peyment";
export const payOrPulished = "/user/ads/publish";
export const payAddOption = "/user/ads/addoption";
export const ShowContactData = "/web/contact_data";
export const checkOffer = "/off/check";
